import { render } from "./Alert.vue?vue&type=template&id=8013d260&scoped=true"
import script from "./Alert.vue?vue&type=script&lang=js"
export * from "./Alert.vue?vue&type=script&lang=js"

import "./Alert.vue?vue&type=style&index=0&id=8013d260&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-8013d260"

export default script